import { deleteApiRequest, postApiRequest, putApiRequest } from "utils/fetch-helper"
import { ALLOW_OVERLAP } from "./calendar"

export const DISPLAY_FORM_TITLE_SUBTITLE = "DISPLAY_FORM_TITLE_SUBTITLE"
export const ENABLE_RECURRING_BOOKINGS = "ENABLE_RECURRING_BOOKINGS"
export const BUSINESS_WEBSITE_KEY = "business_url"
export const ENTRY_POINT_KEY = "ENTRY_POINT"
export const CURRENCY_KEY = "currency"
export const PRIMARY_COLOR_KEY = "primary_color"
export const LOCATION_BG_KEY = "location_bg"
export const BUSINESS_TYPE_KEY = "business_type"
export const REFERRAL_TYPE_KEY = "referral_type"
export const SHOW_SERVICES_INCLUDE_KEY = "display_services_include"
export const ENTRY_WITH_CATEGORY_KEY = 'ENTRY_WITH_CATEGORY'
export const SHOW_INTRO_BORDER = 'SHOW_INTRO_BORDER'
export const INTRO_MESSAGE_KEY = 'INTRO_MESSGAE' // yes there's a typo, but changing this now would result in existing configs to fail


export enum SettingCategory {
    BUSINESS = "BUSINESS",
    ROLE = "ROLE",
    TIME = "TIME"
}

export type SettingDTO = {
    category: SettingCategory
    deletedAt?: string
    id?: string
    name: string
    tenantId?: string
    value: string
}

export type Setting = {
    category: SettingCategory
    deleted_at?: string
    id?: string
    name: string
    tenant_id?: string
    value: string | boolean | number
}

export function mapSettingFromDTO(setting: SettingDTO, value: string | boolean | number): Setting {
    return {
        category: setting.category,
        deleted_at: setting.deletedAt,
        id: setting.id,
        name: setting.name,
        tenant_id: setting.tenantId,
        value,
    } as Setting
}

export function mapSettingToDTO(setting: Setting): SettingDTO {
    return {
        category: setting.category,
        deletedAt: setting.deleted_at,
        id: setting.id,
        name: setting.name,
        tenantId: setting.tenant_id,
        value: setting.value.toString(),
    } as SettingDTO
}

export const DEFAULT_BUSINESS_TYPE: Setting = {
    category: SettingCategory.BUSINESS,
    name: BUSINESS_TYPE_KEY,
    value: "",
}

export const DEFAULT_REFERRAL_TYPE: Setting = {
    category: SettingCategory.BUSINESS,
    name: REFERRAL_TYPE_KEY,
    value: "",
}

export const DEFAULT_SHOW_SERVICES_INCLUDE: Setting = {
    category: SettingCategory.BUSINESS,
    name: SHOW_SERVICES_INCLUDE_KEY,
    value: true,
}

export const DEFAULT_INTRO_MESSAGE: Setting = {
    category: SettingCategory.BUSINESS,
    name: INTRO_MESSAGE_KEY,
    value: "",
}

export const DEFAULT_SHOW_INTRO_BORDER: Setting = {
    category: SettingCategory.BUSINESS,
    name: SHOW_INTRO_BORDER,
    value: false,
}

export const DEFAULT_ALLOW_OVERLAP: Setting = {
    category: SettingCategory.BUSINESS,
    name: ALLOW_OVERLAP,
    value: false,
}

export const handleDBSettingsSave = (
    setting: Setting,
    tenant_id: string
) => {

    let payload = mapSettingToDTO({...setting, tenant_id})

    let res
    if (!!payload.value) {
        if (payload?.id) {
            res = handlePutDbSetting(payload)
        } else {
            res = handlePostDbSetting(payload)
        }
    } else if (payload?.id) {
        res = deleteApiRequest(`/v1/settings/${payload.id}`)
    }

    return res
}

const handlePostDbSetting = async (payload: SettingDTO) => {
    return await postApiRequest('/v1/settings', payload)
}

const handlePutDbSetting = async (payload: SettingDTO) => {
    return await putApiRequest(`/v1/settings/${payload?.id}`, payload)
}
